import React from 'react';
import { Table, Empty, Tooltip ,Tag,Button} from 'antd';

export default function Coutas(props) {
    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Cuota',
                        dataIndex: 'nroCouta',
                        key: 'nroCouta',
                        align: 'center'
                    },
                    {
                        title: 'Fecha Vencimiento',
                        dataIndex: 'fechaVencimiento',
                        key: 'fechaVencimiento'
                    },
        
                    {
                        title: 'Monto de Cuota',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'right',
                        width: 90,
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    },
                    {
                        title: 'Dias Faltantes de Pago',
                        dataIndex: 'diasFaltante',
                        key: 'diasFaltante',
                        align: 'center',

                    },
                 
                    {
                        title: 'Dias de Atraso Pago',
                        dataIndex: 'diasAtraso',
                        key: 'DiasAtraso',
                        align: 'center',

                    },
                    {
                        title: 'Estado',
                        dataIndex: 'idCuentasPagarDetalleEstado',
                        key: 'flag',
                        align: 'center',
                        width: "90px",
                        render: (value) => {
                            
                            return (<div className="custom-options" >
                                <Tag color={value==1 ? "green" : "red"}>{value==1 ? "Pagado" : "Pendiente"}</Tag>
                            </div>)
                        }
                    },
                ]}
            />
        </div>
    );
}